import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';

import { Constants } from './app.constants';

import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable()
export class EchexpaymentService {

  private actionUrl: string;
  private apiKey: string;
  private apiPassword: string;
  
  public th = ['', 'thousand', 'million', 'billion', 'trillion'];
  public dg = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  public tn = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  public tw = ['twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
	
  constructor(private http: HttpClient, private _constants: Constants) {
	this.actionUrl = _constants.ServerWithApiUrl;
    this.apiKey = _constants.APIKey;
    this.apiPassword = _constants.APIPassword;
  }
  
	// two words
	toWords(s)
	{  
	  
		s = s.toString(); 
		s = s.replace(/[\, ]/g,''); 
		if (s != parseFloat(s)) return ''; 
		var x = s.indexOf('.'); 
		if (x == -1) x = s.length; 
		if (x > 15) return 'too big'; 
		var n = s.split(''); 
		var str = ''; 
		var sk = 0; 
		for (var i=0; i < x; i++) 
		{
			if ((x-i)%3==2) 
			{
				if (n[i] == '1') 
				{
					str += this.tn[Number(n[i+1])] + ' '; 
					i++; 
					sk=1;
				}
				else if (n[i]!=0) 
				{
					str += this.tw[n[i]-2] + ' ';
					sk=1;
				}
			}
			else if (n[i]!=0) 
			{

				str += this.dg[n[i]] +' '; 
				if ((x - i) % 3 == 0) str += 'hundred ';
				var str = str.replace("Dollars", "");
				str += ' Dollars';
				sk = 1;
			}


			if ((x-i)%3==1)
			{
				if (sk) str += this.th[(x-i-1)/3] + ' ';
					var str = str.replace("Dollars", "");
					str += ' Dollars';
					sk = 0;
			}
			if(n[i] == 0 && s.charAt(0) === '0'){
				var str = str.replace("Dollars", "");
				str += 'Zero Dollars';
				sk = 0;

			}
		}
		if (x != s.length) {
		var y = s.length;
		if(s.charAt(0) === '.'){
			str += 'Zero Dollars and .';
			for (i = x + 1; i < y; i++) str +=  n[i];
				str +=' Cents';
		}

		if(s.charAt(0) != '.'){
			var str = str.replace("Zero Cents", "");
			str +='.';
			for (i = x + 1; i < y; i++) str += n[i];
				str +=' Cents';
		}
	  }
		return str.replace(/\s+/g,' ');
	}
  
 
  // get merchant lists
  getMerchantList(data){
      let params = new URLSearchParams();
      let url = this.actionUrl + 'merchant/lists';
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(url, {params: {token: data.token}, headers: headers})
      .map((response:Response) => response)
    }
	// Edit merchant plan data
   getEchexMerchantEditPlanData(data){
      var _id =  data.id;
      let params = new URLSearchParams();
      let url = this.actionUrl + 'get/merchant/'+_id;
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      return this.http.get(url, {params: {token: _id}, headers: headers})
      .map((response:Response) => response)
    }
	// Get merchant permission lists as per role
    getMerchantPermissionList(data){
      var _id =  data.id;
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      let url = this.actionUrl + 'get/permissions/role/'+_id;
      return this.http.get(url, {params: {token: data.token,role_id:data.role_id}, headers: headers})
      .map((response:Response) => response)
    }
	// Get each user permission
    getEachUserPermission(data){
      var _id =  data.id;
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      let url = this.actionUrl + 'auth/get/profile/'+_id;
      return this.http.get(url, {params: {token: data.token,role_id:data.role_id}, headers: headers})
      .map((response:Response) => response)
    }
	// Update Merchant profile
    updateMerchantProfile(data, formData){
        var _id = data.id
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'auth/update/profile/'+_id,formData, { headers })
        .map((response:Response) => response)
    }
	// Update Merchant Plan
    updateMerchantPlan(data){
        var _id = data.id
       // return this.http.post(this.actionUrl +'plan/update/'+_id,data)
       // .map((response:Response) => response)
    }
	// Lock or unlock user
    merchantLockUnlock(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      var _id = data.id
      return this.http.post(this.actionUrl +'update/user/'+_id,data,{headers})
      .map((response:Response) => response)
    }
    // Delete Recurring
    DeleteRecurring(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        var _id = data._id
        return this.http.post(this.actionUrl +'disable/cheque/recurrent/'+_id,data,{headers})
        .map((response:Response) => response)
    }

    // Delete Recurring
    DeleteInvoiceRecurring(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        var _id = data._id
        return this.http.post(this.actionUrl +'disable/invoice/recurrent/'+_id,data,{headers})
        .map((response:Response) => response)
    }
	// Delete Merchant
    deleteMerchant(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      var _id = data.id
      return this.http.post(this.actionUrl +'update/user/'+_id,data,{headers})
      .map((response:Response) => response)
    }
    // Ghost Enable
    ghostEnable(data){
      var _id =  data.id;
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
    .set('Authorization', `Bearer ${data.user_token}`);
      let url = this.actionUrl + 'get/passport/token/'+_id;;
      return this.http.get(url, {params: {token: _id}, headers})
      .map((response:Response) => response)
    }
	// Update user Permission
    updateUserPermission(data){
      var _id =  data.id;
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      return this.http.post(this.actionUrl +'update/user/permission/'+_id,data, {headers})
      .map((response:Response) => response)
      
    }
	// Create merchant
    createEchexMerchantApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      var _id =  data.id;
     return this.http.post(this.actionUrl +'create/merchant/'+_id,data, {headers})
        .map((response:Response) => response)
    }
	//Update Merchant
    updateMerchantApi(data){
        var _id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'generate/merchant/api/'+_id,data, {headers})
        .map((response:Response) => response)
    }
	// Whitelist merchant ip
	whitelistMerchantIp(data){
        var _id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'merchant/ip/whitelist/'+_id,data, {headers})
        .map((response:Response) => response)
    }
	// Delete Merchant ip
	deleteMerchantIp(data){
        var _id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.delete(this.actionUrl +'merchant/delete/ip/'+_id,{params: {token: data.token, ip: data.ip}, headers})
        .map((response:Response) => response)
    }
	// Update Merchant Plan
    updateMerchantPlanAPi(data){
        var _id = data.id
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'update/plan/settings/'+_id,data, {headers})
        .map((response:Response) => response)
    }
	// get admin lists
	getAdminList(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      let params = new URLSearchParams();
	  var _id = data.id
      let url = this.actionUrl + 'admin/lists/'+_id;
      return this.http.get(url, {params: {token: data.user_token},headers})
      .map((response:Response) => response)
    }
	// Admin Lock and unlock
    adminLockUnlock(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      var _id = data.id
      return this.http.post(this.actionUrl +'update/user/'+_id,data,{headers})
      .map((response:Response) => response)
    }
	// Create Echex Admin
	createEchexAdmin(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		var _id = data.id
        return this.http.post(this.actionUrl +'auth/register/admin/'+_id, data, {headers})
        .map((response:Response) => response)
    }
	// Create Custom Plan
	createCustom_plan(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		var _id = data.id
        return this.http.post(this.actionUrl +'customer/custom/plan/', data, {headers})
        .map((response:Response) => response)
    }
	/* Permissions */
	// Create Permission
	createPermission(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'permission/create',data,{headers})
        .map((response:Response) => response)
    }
	// Get all permission Lists
 	getAllPermissionList(data){
      let params = new URLSearchParams();
      let url = this.actionUrl + 'permission/lists';
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(url, {headers})
      .map((response:Response) => response)
    }
	// Edit Permission Data
    getEditPermissionData(data){
      var id =  data.id;
      let params = new URLSearchParams();
      let url = this.actionUrl + 'permission/list/'+id;;
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(url, {params: {token: data.token}, headers: headers})
      .map((response:Response) => response)
    }
	// Update Permission
    updatePermission(data){
        var id = data._id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'permission/update/'+id,data, {headers})
        .map((response:Response) => response)
    }
	// Delete Permission
    deletePermission(data){
        var id = data.id;
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'permission/delete/'+id,data,{headers})
        .map((response:Response) => response)
    }
	
	/* INVOICE */
	
	// Get All Invoice Data
	getAllInvoiceData(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'invoice/lists/'+data._id;
        let params = new URLSearchParams();
		return this.http.get(url,{params: {token: data.token}, headers})
        .map((response:Response) => response)
	}
	// View invoice by id
	viewInvoice(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'invoice/view';
        let params = new URLSearchParams();
		return this.http.get(url+'/'+data._id,{params: {token: data.token,invoice_id: data.invoice_id}, headers})
        .map((response:Response) => response)
	}
	// Download Invoice
	downloadInvoice(data)
	{
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		let url = this.actionUrl + 'invoice/download/';
		url = url+data._id+'?token='+data.token+'&invoice_id='+data.invoice_id;
        return this.http.get(url, { responseType: 'blob', headers}).map(
        (res) => {
            return res;
        })
	}
	// Download Multiple invoice
	downloadMultipleInvoice(data)
	{
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
		let url = this.actionUrl + 'invoice/downloadmultiple/';
		url = url+data._id;
		let params = new URLSearchParams();
		return this.http.post(url,data, { responseType: 'blob', headers}).map(
		(res) => {
			return res;
		})
		
	}
	
	
	/* STATUS */
	
	// Create status
	createStatus(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'status/create',data, {headers})
        .map((response:Response) => response)
    }
	// Get all Status
 	getAllStatusData(data){
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(this.actionUrl +'status/lists',{headers})
      	.map((response:Response) => response)
    }
	// Get status by _id
    getEditStatusData(data){
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      return this.http.get(this.actionUrl +'status/list/'+data.id,{headers})
        .map((response:Response) => response)
    }
	// Update status
    updateStatus(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
      return this.http.post(this.actionUrl +'status/update/'+data.id,data, {headers})
        .map((response:Response) => response)
    }
    // Delete status
    deleteStatus(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'status/delete/'+data.id,data, {headers})
        .map((response:Response) => response)
    }
	
	/* EMAIL TEMPLATES */
	// Create email template
	createEmailTemplate(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'emailtemplate/create',data, {headers})
        .map((response:Response) => response)
    }
	// Get all email templates
 	getAllEmailTemplate(data){
      let params = new URLSearchParams();
      const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(this.actionUrl +'emailtemplate/lists',{headers})
      	.map((response:Response) => response)
    }
	// Get template by _id
    getemailTemplateData(data){
      let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.get(this.actionUrl +'emailtemplate/list/'+data.id,{params: {token: data.token}, headers})
        .map((response:Response) => response)
    }
	// Update email template
    updateEmailTemplate(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
      return this.http.post(this.actionUrl +'emailtemplate/update/'+data.id,data, {headers})
        .map((response:Response) => response)
    }
    // delete email template
    deleteTemplate(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'emailtemplate/delete/'+data.template_id,data, {headers})
        .map((response:Response) => response)
    }
	
	/* PLAN */
	// create plan
	createPlan(data){        
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'plan/create',data,{headers})
        .map((response:Response) => response)
    }
	// list all plan
	getAllPlan(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.get(this.actionUrl +'plan/lists',{headers})
            .map((response:Response) => response)
	}
	// get plan data by id
    getEditPlanData(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.get(this.actionUrl +'plan/list/'+data.id,{headers})
        .map((response:Response) => response)
    }
	// update plan
    updatePlan(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'plan/update/'+data._id,data,{headers})
        .map((response:Response) => response)
    }
	// delete plan
 	deletePlan(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.post(this.actionUrl +'plan/delete/'+data.id,data,{headers})
        .map((response:Response) => response)
    }
	
	/* SEND CHEQUE */
	// create sent cheque
	createSendCheckApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'create/send/cheque/'+data._id,data,{headers})
        .map((response:Response) => response)
    }
	// get default cheque number
	getDefaultCheckNumberApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
    var id = data.id;
    return this.http.get(this.actionUrl +'get/cheque/number/default/'+id,{params: {token: data.token,     checking_account_number:data.checking_account_number,routing_number:data.routing_number}, headers})
        .map((response:Response) => response)
	}

	// Download multiple cheque plain paper
    downloadMultipleCheck(data)
    {
       /* const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'print/cheque/paper/';
        
        url = url+data._id;
        //let params = new URLSearchParams();
        return this.http.post(url,data, { responseType: 'blob' , headers}).map(
        (res) => {
            return res;
        })
        */

    }
	// Download multiple mobile cheque
    downloadMultipleFormobileCheck(data) {
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'print/cheque/image/';
        url = url+data._id;
        return this.http.post(url,data, { responseType: 'blob', headers }).map(
        (res) => {
            return res;
        })
    }
	// Want to print
    wantToPrintCheckApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'want/to/print/'+data.id,data, {headers})
        .map((response:Response) => response)   
    }
	// Print send cheque
    printSendChequeApi(data) {
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        let url = this.actionUrl + 'print/send/cheque/image';
        return this.http.post(url,data, { responseType: 'blob', headers }).map(
        (res) => {
            return res;
        })
    }
	// Update print check status
    updatePrintCheckStatusApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'update/cheque/print/status/'+data._id,data, {headers})
        .map((response:Response) => response)  
    }
	
	/* GENERATE URLS */
	// Get cheque lists
	getChequeListApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
		var id = data.id;
		let params = new URLSearchParams();
		let url = this.actionUrl + 'lists/cheque/'+id;
		return this.http.get(url, {params: {token: data.token}, headers})
		  .map((response:Response) => response)
	}
	// Generate cheque url
	generateChequeUrlApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
	  return this.http.post(this.actionUrl +'generate/bank/auth/link/'+data.id,data,{headers})
		.map((response:Response) => response)
	}
	// get bank info
	getBankInfoApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
		return this.http.get(this.actionUrl +'get/bank/auth/info/'+data.id+'/'+data.token,{headers: headers})
		.map((response:Response) => response) 
	}

    // get bank info
	getInvoiceBankInfoApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
		return this.http.get(this.actionUrl +'get/invoice/bank/auth/info/'+data.id+'/'+data.token+'/'+data.invoice_id,{headers: headers})
		.map((response:Response) => response) 
	}
	// get info from plaid
	getInfoFromPlaidApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
	  return this.http.post(this.actionUrl +'get/plaid/info',data,{headers: headers})
		.map((response:Response) => response) 
	}
	// save cheque bank auth
    payChequeFromBankAuthApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
      return this.http.post(this.actionUrl +'create/bank/auth/cheque/'+data._id,data, {headers: headers})
        .map((response:Response) => response)
    }

    // save invoice cheque bank auth
    payInvoiceChequeFromBankAuthApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
      return this.http.post(this.actionUrl +'create/invoice/bank/auth/cheque/'+data._id,data, {headers: headers})
        .map((response:Response) => response)
    }
	// save cheque
    saveChequeApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
       return this.http.post(this.actionUrl +'create/enter/cheque/'+data._id,data, {headers})
        .map((response:Response) => response)
    }
    updateChequeApi(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        return this.http.post(this.actionUrl +'update/cheque/'+data.id,data, {headers})
         .map((response:Response) => response)
     }
	// save cheque from checkout url
    payChequeFromSecureLinkApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'create/secure/checkout/cheque/'+data._id,data, {headers: headers})
        .map((response:Response) => response)
    }

    // save cheque from checkout url
    payInvoiceChequeFromSecureLinkApi(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'create/invoice/secure/checkout/cheque/'+data._id,data, {headers: headers})
        .map((response:Response) => response)
    }
	
	/* TRANSACTIONS */
	// Get transcations data 
	getAllTransactionData(data){
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);  
      return this.http.post(this.actionUrl +'lists/cheque/'+data._id,data,{headers})
        .map((response:Response) => response)
		
	}
	// Get adavanced transcations data 
    getAllTransactionAdvanceData(data){
        let params = new URLSearchParams(); 
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`); 
        return this.http.post(this.actionUrl +'lists/cheque/'+data._id,data,{headers})
        .map((response:Response) => response)
	}
	// Get all merchant dropdown
    getAllMerchantForDropDownApi(data){
        let params = new URLSearchParams();  
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`); 
        return this.http.get(this.actionUrl +'merchant/lists/transcations/'+data._id,{params: {token: data.token}, headers: headers})
        .map((response:Response) => response)
    }
	// Get merchant Users
    getMerchantUserApi(data){
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);   
        return this.http.get(this.actionUrl +'merchant/users/lists/transcations/'+data._id,{params: {token: data.token,echex_merchant_token :data.echex_merchant_token}, headers: headers})
        .map((response:Response) => response)
    }
	// Print for bank deposit
    printForBankDepositApi(data)
    {
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Access-Control-Allow-Origin', '*')
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'print/cheque/paper/';
        url = url+data._id;
        return this.http.post(url,data, { responseType: 'blob', headers }).map(
        (res) => {
            return res;
        })

    }
	// Print for mobile deposit
    printForMobileAppApi(data)
    {
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
        let url = this.actionUrl + 'print/cheque/image/';
        url = url+data._id;
        return this.http.post(url,data, { responseType: 'blob', headers }).map(
        (res) => {
            return res;
        })
    }
	// Edit Transaction data
    getEchexTransactionDetail(data){
        var _id =  data.id;
        let params = new URLSearchParams();
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`); 
        let url = this.actionUrl + 'get/cheque/'+_id;;
        return this.http.get(url, {params: {token: data.token, _id: data._id}, headers:headers})
        .map((response:Response) => response)
    }


    // get merchant lists
    getAllMerchantList(data){
        let params = new URLSearchParams();
        let url = this.actionUrl + 'merchant/allusers/lists';
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.token}`);
        return this.http.get(url, {headers: headers})
        .map((response:Response) => response)
    }

    // Check direct deposit
    checkDirectDepositData(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
        return this.http.post(this.actionUrl +'check/direct/deposit/'+data.id,data, {headers})
        .map((response:Response) => response)   
    }

    // save deposit data
	saveDepositCustomerInfo(data){
        const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set(this.apiKey, this.apiPassword);
	  return this.http.post(this.actionUrl +'direct/deposit/cheque',data,{headers: headers})
		.map((response:Response) => response) 
	}

    // Check direct deposit
    checkDirectDepositWithMerchant(data){
        const headers = new HttpHeaders()
        .set('Authorization', `Bearer ${data.user_token}`);
	    return this.http.post(this.actionUrl +'check/direct/deposit/merchant/'+data.merchant_id, data,{headers})
		.map((response:Response) => response)
    }
    

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/echexpayment.service.ts